<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :delete_url="delete_url"
      :urls="urls"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import ActionsDialog from "@/own/components/settings/notifications/ActionsDialog";
import {
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
  UPDATE_ACTIONS_DIALOG_SERVER_DATA,
} from "@/core/services/store/notifications.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import { SET_FILTERS_DATA } from "@/core/services/store/filter.module";

export default {
  name: "Notifications",
  components: { DataTable },
  data: () => ({
    delete_url: `${process.env.VUE_APP_BASE_URL}/settings/notifications/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      UPDATE_ACTIONS_DIALOG_SERVER_DATA: UPDATE_ACTIONS_DIALOG_SERVER_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
    },
    store_names: {
      getTableFilters: "getNOTIFICATIONSTableFilters",
      getTableState: "getNOTIFICATIONSTableState",
      getTableData: "getNOTIFICATIONSTableData",
      getTableHeaders: "getNOTIFICATIONSTableHeaders",
      getTableProperties: "getNOTIFICATIONSTableProperties",
      getTablePermissions: "getNOTIFICATIONSTablePermissions",
    },
    urls: {
      status: "/settings/notifications/update_status",
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
      await this.$store
        .dispatch(this.table_state.UPDATE_ACTIONS_DIALOG_SERVER_DATA, {})
        .then(() => {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },

    componentForEditing: function () {
      return ActionsDialog;
    },
    componentForAdding: function () {
      return ActionsDialog;
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.$store.commit(SET_FILTERS_DATA, {});
    this.initTableContent();
  },
};
</script>
